import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axiosClient from "../api/axiosClient";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { toast } from "react-hot-toast";
import Swal from "sweetalert2";
import {plans} from "../script/paymentPlans.js"
import "../styles/Payment.css"

export default function PaymentPage() {
  const navigate = useNavigate();
  const [paymentLoading, setPaymentLoading] = useState(false);
const [promoCodes, setPromoCodes] = useState({});
  const [activePlan, setActivePlan] = useState(null);
const isHomePage = window.location.pathname === "/";
 const getDemoKey = (userId, courseName) => {
  const normalizedCourse = courseName?.toLowerCase().replace(/\s+/g, "_");
  return `demo_${userId}_${normalizedCourse}`;
};

  const location = useLocation();
  const courseName =
    location.state?.courseName || localStorage.getItem("selectedCourse");

// ----------------- YAHAN RAKHNA HAI (EXACT)
  const getPurchaseKey = (userId, courseName, planName) => {
    const normalizedCourse = courseName?.toLowerCase().replace(/\s+/g, "_");

    const normalizedPlan = planName.toLowerCase();

    return `purchase_${userId}_${normalizedCourse}_${normalizedPlan}`;
  };
  useEffect(() => {
    if (courseName) {
      localStorage.setItem("selectedCourse", courseName);
    }
  }, [courseName]);

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) {
        resolve(true);
        return;
      }
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handlePayment = async (plan) => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");

 // 🔥--------------------- KEY SABSE PEHLE
    const purchaseKey = getPurchaseKey(userId, courseName, plan.name);

// 1️⃣ ---------------------LOGIN CHECK
    if (!token) {
      Swal.fire({
        icon: "warning",
        title: "Login Required",
        text: "Please login first to continue.",
        confirmButtonColor: "#6366f1",
      }).then(() => navigate("/login"));
      return;
    }

// 2️⃣---------------SAME COURSE + SAME PLAN BLOCK
    const alreadyPurchased = localStorage.getItem(purchaseKey) === "true";

    if (alreadyPurchased) {
      Swal.fire({
        icon: "info",
        title: "Already Purchased",
        text: "You have already purchased this plan for this course. Try another plan.",
        confirmButtonColor: "#6366f1",
      });
      return;
    }

// ================= FREE PLAN =================
  if (plan.name === "Free") {
  const demoKey = getDemoKey(userId, courseName);
  const alreadyDemo = localStorage.getItem(demoKey) === "true";

  // ✅ SAME COURSE → BLOCK
  if (alreadyDemo) {
    Swal.fire({
      icon: "info",
      title: "Already Activated",
      text: "Demo already activated for this course.",
      confirmButtonColor: "#6366f1",
    });
    return;
  }

  try {
    setPaymentLoading(true);

    const res = await axiosClient.post(
      "/auth/api/payments/activate-free",
      null,
      {
        params: {
          courseName,
          planName: "FREE",
        },
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    // ✅ SAVE ONLY THIS COURSE
    localStorage.setItem(demoKey, "true");

    toast.success(res.data?.message || "Demo activated");
    navigate("/front");
  } catch (e) {
    Swal.fire({
      icon: "warning",
      title: "Notice",
      text: e.response?.data?.message || "Demo already activated",
    });
  } finally {
    setPaymentLoading(false);
    setActivePlan(null);
  }

  return;
}

// ================= PAID PAYMENT =================
    try {
      setPaymentLoading(true);

      const loaded = await loadRazorpayScript();
      if (!loaded) {
        toast.error("Razorpay failed to load");
        return;
      }

      const res = await axiosClient.post(
        "/auth/api/payments/create-order",
        null,
        {
          params: {
            courseName,
            planName: plan.name.toUpperCase(),
          promoCode: promoCodes[plan.name] || null,
          },
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const order = res.data.data || res.data;

      const options = {
        key: "rzp_live_SYZNjqzmznpzEC",
        amount: order.amount,
        currency: "INR",
        name: "CodeMatrix",
        description: `${plan.name} Plan`,
        order_id: order.orderId || order.id,

        handler: async (rp) => {
          await axiosClient.post("/auth/api/payments/verify-payment", null, {
            params: {
              orderId: rp.razorpay_order_id,
              paymentId: rp.razorpay_payment_id,
              signatureId: rp.razorpay_signature,
              courseName,
            },
          });

// 🔥 YE LINE ADD KARO
          localStorage.setItem(purchaseKey, "true");
          // ✅ ONLY HERE SAVE PURCHASE

          toast.success("Payment Successful 🎉");
          navigate("/front", { state: { selectedCourse: courseName } });
        },

        
        modal: {
          ondismiss: () => setPaymentLoading(false),
        },

        theme: { color: "#6366f1" },
      };

      new window.Razorpay(options).open();
    } catch (err) {

  const msg = err.response?.data?.message;

  if (
  msg?.toLowerCase().includes("pehle") ||
  msg?.toLowerCase().includes("already")
) {

    Swal.fire({
      icon: "info",
      title: "Already Purchased",
      text: msg,
      confirmButtonColor: "#6366f1",
    });
  } 
  else {
    Swal.fire({
      icon: "error",
      title: "Payment Failed",
      text: msg || "Something went wrong",
    });
  }

}
  // 🔥 YE 2 LINE MOST IMPORTANT
  setPaymentLoading(false);
  setActivePlan(null);

  };
  

const getUpdatedPlans = (courseName) => {

 const isHomePage = window.location.pathname === "/"
  // ✅ ALWAYS FIXED PRICE ON HOMEPAGE
  if (isHomePage) {
    return plans.map((plan) => {
      if (plan.name === "Basic") {
        return { ...plan, price: 4999, displayPrice: "₹4999" };
      }
      if (plan.name === "Standard") {
        return { ...plan, price: 7999, displayPrice: "₹7999" };
      }
      if (plan.name === "Premium") {
        return { ...plan, price: 9999, displayPrice: "₹9999" };
      }
      return plan;
    });
  }

  // ✅ OTHER PAGES (your existing logic)
  const techCourses = ["python","c","java"];
  const isTechCourse = techCourses.includes(courseName?.toLowerCase());

  if (!isTechCourse) return plans;

  return plans.map((plan) => {
    if (plan.name === "Basic") {
      return { ...plan, price: 599, displayPrice: "₹599" };
    }
    if (plan.name === "Standard") {
      return { ...plan, price: 899, displayPrice: "₹899" };
    }
    if (plan.name === "Premium") {
      return { ...plan, price: 1099, displayPrice: "₹1099" };
    }
    return plan;
  });
};
  return (
    // <div className="payment-page-container">
    
    <div style={{ textAlign: "center", padding: "0px 10px" }}>
        <h1 className="animated-pricing-title">Pricing Plans</h1>
        <p
          style={{ color: "#64748b", fontSize: "1.2rem", marginBottom: "50px" }}
        >
          Select the blueprint for your{" "}
          <span style={{ color: "#6366f1", fontWeight: "700" }}>
            Ultimate Transformation
          </span>
        </p>

        <div className="pricing-grid">
          {getUpdatedPlans(courseName).map((plan, index) => {
  const isPaid = plan.name !== "Free";

  return (
    <div
      key={index}
      className="plan-card"
      style={{
        border: plan.popular ? "2px solid #6366f1" : "",
        position: "relative",
      
        opacity: isPaid ? 0.85 : 1,
      }}
    >

      {/* {plan.name !== "Free" && (
  <div
    style={{
      position: "absolute",
      inset: 0,
      background: "rgba(255,255,255,0.6)",
     
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "30px",
      zIndex: 5,
      fontWeight: "bold",
      fontSize: "1.1rem",
      color: "#1e293b",
    }}
  >
    Demo Only
  </div>
)} */}
              {plan.popular && (
                <div
                  style={{
                    position: "absolute",
                    top: "15px",
                    right: "-35px",
                    background: "#6366f1",
                    color: "white",
                    padding: "5px 40px",
                    transform: "rotate(45deg)",
                    fontSize: "10px",
                    fontWeight: "900",
                  }}
                >
                  BEST VALUE
                </div>
              )}

              <h3 style={{ fontSize: "1.4rem", color: "#475569", margin: 0 }}>
                {plan.name}
              </h3>
              <div
                style={{
                  fontSize: "2.8rem",
                  fontWeight: "900",
                  color: "#1e293b",
                  margin: "20px 0",
                  display:"flex",
                  justifyContent:"center",
                  alignItems:"center",
                  gap:"6px"
                }}
              >
               <span>{plan.displayPrice}</span>
               {/*for showing - /month ,/year */}
               <span
               style={{
                fontSize:"1rem",
                fontWeight:"500",
                color:"#64748b",
                marginTop:"17px"
               }}
               >{plan.duration}</span>
              </div>



{/*
{plan.name !=="Free" && (
               <div
                style={{
                  fontSize: "1rem",
                  fontWeight: "500",
                  color: "#1e293b",
                  display:"flex",
                  justifyContent:"flex-end",
                  alignItems:"flex-end",
                  marginTop:"-27px",
                  marginBottom:"10px",
                }}
              >
              
               {plan.dollarFormatPrice()}
              </div>
)}
*/}
              <button
               onClick={() => {
          // if (plan.name !== "Free") {
          //   Swal.fire({
          //     icon: "info",
          //     title: "Demo Available",
          //     text: "Currently only Demo plan is available.",
          //     confirmButtonColor: "#6366f1",
          //   });
          //   return;
          // }

  setActivePlan(plan.name);
  handlePayment(plan);
}}
                disabled={paymentLoading && activePlan === plan.name}
                style={{
                  width: "100%",
                  padding: "16px",
                  background: plan.popular ? "#6366f1" : "#1e293b",
                  color: "white",
                  borderRadius: "15px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "800",
                  marginBottom: "30px",
                  boxShadow: plan.popular
                    ? "0 10px 20px rgba(99, 102, 241, 0.2)"
                    : "none",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  opacity: paymentLoading && activePlan === plan.name ? 0.7 : 1,
                }}
              >
                {paymentLoading && activePlan === plan.name ? (
                  <Loader2 className="animate-spin" size={20} />
                ) : plan.isTeam ? (
                  "Try Demo"
                ) : (
                  "Proceed Now"
                )}
              </button>

{/* ----------------Promocode----------------- */}
              {!plan.isTeam && (
                <input
                  type="text"
                  placeholder="Enter Promo Code"
                 value={promoCodes[plan.name] || ""}
onChange={(e) =>
  setPromoCodes((prev) => ({
    ...prev,
    [plan.name]: e.target.value,
  }))
}
                  style={{
                    width: "100%",
                    padding: "14px",
                    borderRadius: "12px",
                    border: "1px solid #e2e8f0",
                    marginBottom: "18px",
                    fontSize: "14px",
                    outline: "none",
                  }}
                />
              )}

              <div style={{ textAlign: "left", flexGrow: 1 }}>
                {plan.features.map((feat, i) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginBottom: "12px",
                      color: "#475569",
                      fontSize: "0.95rem",
                    }}
                  >
                    <CheckCircle2 size={18} color="#10b981" /> {feat}
                  </div>
                ))}
                {/*
                {plan.excluded.map((feat, i) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginBottom: "12px",
                      color: "#cbd5e1",
                      textDecoration: "line-through",
                      fontSize: "0.95rem",
                    }}
                  >
                    <XCircle size={18} color="#cbd5e1" /> {feat}
                  </div>
                ))}
                  */}
              </div>
            </div>
           );
  })}
        </div>
      </div>
    // </div>
  );
}
